export const FETCH_SONGS = 'FETCH_SONG';
export const SONG_SELECTED = 'SONG_SELECTED';
